import React, { useState } from 'react';
import { TextField, Button, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import * as userService from '../../../services/UserService';
import './createUser.scss';
import BackButton from './../../../components/BackButton/BackButton';
import Swal from 'sweetalert2';

const CreateUser = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    try {
      const userData = {
        name: name,
        email: email,
        phone: phone,
        password: password,
        confirm: confirm
      };

      const res = await userService.addUser(userData);

      if (res.status === 201) {
        Swal.fire(
          'Utilisateur créé !',
          'Création de l\'utilisateur avec succès',
          'success'
        );
        setTimeout(() => {
          navigate('/user'); 
        }, 2000);
      } else {
        Swal.fire(
          'Nope',
          'Une erreur s\'est produite',
          'error'
        );
      }
    } catch (err) {
      console.error("Erreur lors de l'ajout de l'utilisateur :", err);
      Swal.fire(
        'Nope',
        'Une erreur s\'est produite',
        'error'
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="back" style={{margin:"10px 0 0 30px"}}>
        <BackButton />
      </div>

      <div className="create-user">
        <span className="titre">Nouveau Utilisateur</span>

        <div className="form-user">
          <form onSubmit={handleSubmit}>
            <TextField
              type="text"
              label="Nom"
              variant="outlined"
              margin="normal"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />

            <TextField
              type="email"
              label="Email"
              variant="outlined"
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <TextField
              type="tel"
              label="Téléphone"
              variant="outlined"
              margin="normal"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />

            <TextField
              type="password"
              label="Mot de passe"
              variant="outlined"
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <TextField
              type="password"
              label="Confirmer le mot de passe"
              variant="outlined"
              margin="normal"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
            />

            <Button type="submit" variant="contained" disabled={isLoading}>
              {isLoading ? <CircularProgress size={24}/> : "Valider"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateUser;